/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Document,
  Document$inboundSchema,
  Document$Outbound,
  Document$outboundSchema,
} from "./document.js";

export type DocumentRetrievedResponse = {
  document?: Document | undefined;
};

/** @internal */
export const DocumentRetrievedResponse$inboundSchema: z.ZodType<
  DocumentRetrievedResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  document: Document$inboundSchema.optional(),
});

/** @internal */
export type DocumentRetrievedResponse$Outbound = {
  document?: Document$Outbound | undefined;
};

/** @internal */
export const DocumentRetrievedResponse$outboundSchema: z.ZodType<
  DocumentRetrievedResponse$Outbound,
  z.ZodTypeDef,
  DocumentRetrievedResponse
> = z.object({
  document: Document$outboundSchema.optional(),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DocumentRetrievedResponse$ {
  /** @deprecated use `DocumentRetrievedResponse$inboundSchema` instead. */
  export const inboundSchema = DocumentRetrievedResponse$inboundSchema;
  /** @deprecated use `DocumentRetrievedResponse$outboundSchema` instead. */
  export const outboundSchema = DocumentRetrievedResponse$outboundSchema;
  /** @deprecated use `DocumentRetrievedResponse$Outbound` instead. */
  export type Outbound = DocumentRetrievedResponse$Outbound;
}

export function documentRetrievedResponseToJSON(
  documentRetrievedResponse: DocumentRetrievedResponse,
): string {
  return JSON.stringify(
    DocumentRetrievedResponse$outboundSchema.parse(documentRetrievedResponse),
  );
}

export function documentRetrievedResponseFromJSON(
  jsonString: string,
): SafeParseResult<DocumentRetrievedResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DocumentRetrievedResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DocumentRetrievedResponse' from JSON`,
  );
}
